import { ItemModel } from './ItemModel'
import eventBus from '@/plugins/eventBus'
import Model from 'scomponent/src/data/model'
import { ItemCartModel } from '@/store/models/ItemCartModel'
import { UserModel } from './UserModel'

export class CartModel extends Model {
  private static instance: CartModel = new CartModel()
  public count: number = 0
  public total: number = 0
  public items: ItemCartModel[] = []

  public static getInstance(): CartModel {
    return CartModel.instance
  }

  addItems(item: ItemModel, quantity?: any) {
    let found: boolean = false

    this.items.forEach((record: ItemCartModel, i: any) => {
      if (item.id === record.productId) {
        found = true
        console.log(this.items[i], 'item')
        // this.items[i].setQuantity(quantity)
        this.items[i].quantity += quantity
      }
    })

    if (!found) {
      const cartItem = new ItemCartModel().assignItemData(item)
      console.log(cartItem, 'cartitem')
      cartItem.quantity = quantity
      this.items.push(cartItem)

      this.count++
    }
    this.calculateTotal()
    this.localPersist()
  }

  updateQuantity(item: any) {
    let total: number = 0

    this.items.forEach((record: any, i: number) => {
      if (item.itemId === record.productId) {
        this.items[i].setQuantity(item.quantity)
      }
      total = total + record.price * this.items[i].quantity
    })
    this.localPersist()
    return (this.total = total)
  }

  calculateTotal() {
    let total: number = 0

    this.items.forEach((record: any, i: number) => {
      total = total + record.price * this.items[i].quantity
    })
    return (this.total = total)
  }

  removeItem(index: number) {
    this.items.splice(index, 1)
    this.count--
    this.localPersist()
    return this.calculateTotal()
  }

  getItems() {
    return this.items
  }

  localFetch() {
    if (!UserModel.getInstance().isLogged()) {
      let unAuthStorageCart = localStorage.getItem('unAuthCart')
      if (unAuthStorageCart && unAuthStorageCart !== '') {
        let unAuthItemsData = JSON.parse(unAuthStorageCart)
        this.items = unAuthItemsData.map((itemData: any) => new ItemCartModel().assignLocalData(itemData))
        this.count = this.items.length
        this.calculateTotal()
      }
    } else {
      let localStorageCart = localStorage.getItem('cart')
      if (localStorageCart && localStorageCart !== '') {
        let itemsData = JSON.parse(localStorageCart)

        this.items = itemsData.map((itemData: any) => new ItemCartModel().assignLocalData(itemData))
        this.count = this.items.length
        this.calculateTotal()
      }
    }
  }

  private localPersist(): void {
    localStorage.setItem('cart', JSON.stringify(this.items))
    localStorage.setItem('unAuthCart', JSON.stringify(this.items))
  }
}
